import { render } from "./emoji_picker.vue?vue&type=template&id=0a2f7b1e"
import script from "./emoji_picker.js?vue&type=script&lang=js&external"
export * from "./emoji_picker.js?vue&type=script&lang=js&external"

import "./emoji_picker.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__